import { PhoneNumber } from "./phoneNumber/PhoneNumber";
import { isVerifying, PortInStep } from "./portInStep";
import { ValidationCode } from "./validationCode/ValidationCode";
import type { FieldValues, UseFormMethods } from "react-hook-form";
import { INetwork } from "@interface/IPortinForm";

interface IParams<TFieldValues extends FieldValues = FieldValues> {
    formMethods: UseFormMethods<TFieldValues>;
    hasTooManyAttempt: boolean;
    portInStep: PortInStep;
    phoneNumberSelected: string;
    previousPhoneNumber?: string;
    setIsFinished(newValue: boolean): void;
    updatePortInStep(nextStep: PortInStep): void;
    setHasTooManyAttempt(hasTooManyAttempt: boolean): void;
    setCurrentProvider(currentProvider: INetwork): void;
    setPhoneNumberSelected(phoneNumber: string): void;
    namePrefix?: string;
    clearCardError?(): void;
}

export const ValidatePhoneNumberView = <TFieldValues extends FieldValues = FieldValues>(
    props: IParams<TFieldValues>
) => {
    const {
        portInStep,
        setIsFinished,
        updatePortInStep,
        previousPhoneNumber,
        setCurrentProvider,
        hasTooManyAttempt,
        setHasTooManyAttempt,
        formMethods,
        phoneNumberSelected,
        setPhoneNumberSelected,
        namePrefix,
        clearCardError,
    } = props;

    const displayValidationCode = isVerifying(portInStep);

    return (
        <>
            {!displayValidationCode && (
                <PhoneNumber
                    clearCardError={clearCardError}
                    formMethods={formMethods}
                    hasTooManyAttempt={hasTooManyAttempt}
                    namePrefix={namePrefix}
                    phoneNumberSelected={phoneNumberSelected}
                    portInStep={portInStep}
                    previousPhoneNumber={previousPhoneNumber}
                    setCurrentProvider={setCurrentProvider}
                    setHasTooManyAttempt={setHasTooManyAttempt}
                    setIsFinished={setIsFinished}
                    setPhoneNumberSelected={setPhoneNumberSelected}
                    updatePortInStep={updatePortInStep}
                />
            )}
            {displayValidationCode && (
                <ValidationCode
                    clearCardError={clearCardError}
                    formMethods={formMethods}
                    namePrefix={namePrefix}
                    phoneNumberSelected={phoneNumberSelected}
                    setHasTooManyAttempt={setHasTooManyAttempt}
                    setIsFinished={setIsFinished}
                    updatePortInStep={updatePortInStep}
                />
            )}
        </>
    );
};
